module.exports = __webpack_public_path__ + "media/images/logos/glincard-white-2ab06820afa9e5481f7a05833a193a5b.svg";